import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const NameFormatter = ({ row }) => {
  return (
    <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0 }}>
      <span style={{ fontSize: 16, fontWeight: 700, color: '#222' }}>{row.original_filename || ''}</span>
      <span style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{row.name || ''}</span>
    </span>
  );
};

const NameTypeProvider = props => <DataTypeProvider formatterComponent={NameFormatter} {...props} />;

export default NameTypeProvider;
